import { PILL_TONES } from "@/lib/data";

/** Soft, natural-toned pill badge. tone ∈ red | amber | yellow | green. */
const PillBadge = ({ children, tone = "green", className = "" }) => (
  <span className={`inline-block text-xs font-semibold px-3 py-1 rounded-full border ${PILL_TONES[tone] || PILL_TONES.green} ${className}`}>
    {children}
  </span>
);

export default PillBadge;
